(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews-grid-suhang"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.review-card');
  
  cards.forEach(card => {
    const content = card.querySelector('.review-card__content');
    const hasImage = card.querySelector('.review-card__image');
    const hasVideo = card.querySelector('.review-card__video');
    
    // 检查是否只有图片/视频，没有其他内容
    if ((hasImage || hasVideo) && content) {
      const hasText = content.textContent.trim().length > 0;
      
      if (!hasText) {
        card.classList.add('review-card--media-only');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
